
import React from 'react';
import { Shield, Database, Server, Clock, Zap, PieChart } from "lucide-react";

const Introduction = () => {
  return (
    <section id="introduction" className="py-20 px-6 bg-white">
      <div className="max-w-3xl mx-auto text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-dark">
          Modernste KI-Technologie mit voller Kontrolle über deine Daten
        </h2>
        <p className="text-grey text-lg leading-relaxed">
          Willst du modernste KI-Technologie nutzen, aber die volle Kontrolle über deine Daten behalten? 
          Unsere Lösung bringt die Power von ChatGPT direkt auf deine eigene Infrastruktur – mit deutschem Hosting, 
          vollständiger Datenkontrolle und nahtloser Integration in deine bestehenden Systeme.
        </p>
      </div>
      
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
        <div className="bg-secondary rounded-xl p-6 shadow-custom">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
            <Shield className="text-primary" />
          </div>
          <h3 className="text-xl font-semibold mb-4 text-dark">Maximale Sicherheit</h3>
          <p className="text-grey">
            Alle deine Daten bleiben zu 100% unter deiner Kontrolle und auf deutschen Servern - 
            vollständig DSGVO-konform und mit höchsten Sicherheitsstandards.
          </p>
        </div>
        
        <div className="bg-secondary rounded-xl p-6 shadow-custom">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
            <Database className="text-primary" />
          </div>
          <h3 className="text-xl font-semibold mb-4 text-dark">Integrierbare Lösung</h3>
          <p className="text-grey">
            Nahtlose Anbindung an deine Microsoft-Benutzerverwaltung und Integration in bestehende Unternehmensprozesse.
          </p>
        </div>
        
        <div className="bg-secondary rounded-xl p-6 shadow-custom">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
            <Server className="text-primary" />
          </div>
          <h3 className="text-xl font-semibold mb-4 text-dark">Auf deinen Servern</h3>
          <p className="text-grey">
            Installation und Konfiguration der gesamten Infrastruktur auf deinen eigenen Servern 
            mit vollständiger Kontrolle über alle Komponenten.
          </p>
        </div>
      </div>
      
      <div className="max-w-3xl mx-auto mt-16">
        <div className="bg-secondary rounded-xl p-8 shadow-custom">
          <h3 className="text-2xl font-bold mb-6 text-center text-dark">Messbarer Mehrwert für Ihr Unternehmen</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-3">
                <Clock className="text-primary" size={28} />
              </div>
              <p className="font-bold text-xl text-primary"></p>
              <p className="text-grey">Schnellere Informationsfindung</p>
            </div>
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-3">
                <Zap className="text-primary" size={28} />
              </div>
              <p className="font-bold text-xl text-primary"></p>
              <p className="text-grey">Produktivitätssteigerung</p>
            </div>
            <div className="text-center">
              <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-3">
                <PieChart className="text-primary" size={28} />
              </div>
              <p className="font-bold text-xl text-primary"></p>
              <p className="text-grey">Entlastung des IT-Supports</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;
